{
  "auth": {
    "resetPassword": "Réinitialiser votre mot de passe",
    "cancel": "Annuler",
    "send": "Envoyer",
    "email": "Email",
    "password": "Mot de passe",
    "login": "Se connecter",
    "confirmPassword": "Confirmer le mot de passe",
    "save": "Enregistrer",
    "emailValid": "Email valide requis",
    "passwordsDifferent": "Les mots de passe sont pas validés",
    "connect": "Connectez-vous !",
    "forgotPassword": "Mot de passe oublié ?",
    "noCompte": "Pas encore de compte ?",
    "passwordNotGood": "Mot de passe pas validé",
    "passwordValid": "Mot de passe pas validé (une longueur minimale de 12 caractères, contenant lettre en majuscule, en miniscule, chiffre et caractère spécial)",
    "rememberMe": "Se souvenir de moi",
    "register": "Inscrivez-vous !",
    "lastName": "Nom",
    "firstName": "Prénom",
    "phone": "Numero de téléphone",
    "signUp": "S'inscrire",
    "alreadyHaveAccount": "Vous avez déjà un compte ? ",
    "phoneValid": "Numéro de téléphone requis",
    "lastNameValid": "Nom requis",
    "firstNameValid": "Prénom requis",
    "clientsProjects": "Clients",
    "toast-newpassword": "Un email de réinitialisation de mot de passe vous a été envoyé. Veuillez vérifier votre boite mail.",
    "passwordResetSuccess": "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter."
  },
  "client": {
    "noClient": "Vous n'avez pas de client.",
    "create": "Créer un client",
    "title": "Clients",
    "form": {
      "title": "Créer un client",
      "editTitle": "Modifier un client",
      "uploadLogo": "Télécharger un logo",
      "dragAndDrop": "Glissez et déposez le fichier ici",
      "orChooseFile": "ou choisir un fichier",
      "clientName": "Nom du client",
      "clientEmail": "Email du client",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "nameRequired": "Le nom du client est requis",
      "emailRequired": "L'email du client est requis"
    },
    "deleteTitle": "Supprimer le client",
    "deleteMessage": "Voulez-vous vraiment supprimer le client {{name}} ?",
    "deleteSuccess": "Client supprimé avec succès",
    "delete": "Supprimer",
    "updateSuccess": "Client modifié avec succès",
    "createSuccess": "Client créé avec succès",
    "notFound": {
      "title": "Client introuvable",
      "message": "Ce client n'existe pas ou vous n'y avez pas accès.",
      "backToHome": "Retour à l'accueil"
    }
  },
  "demo": {
    "reset": "Réinitialiser la démo",
    "resetSuccess": "Démo réinitialisée",
    "resetError": "Échec de la réinitialisation de la démo",
    "resetConfirm": "Réinitialiser toutes les données de démo ? Cette action est destructive.",
    "resetConfirmTitle": "Réinitialiser la démo"
  },
  "project": {
    "notFound": {
      "title": "Projet introuvable",
      "message": "Ce projet n'existe pas ou vous n'y avez pas accès.",
      "backToHome": "Retour à l'accueil"
    },
    "emptyNetwork": {
      "title": "Réseau vide",
      "message": "Ce réseau n'a pas encore de tracé à afficher. Complétez-le depuis les paramètres (voies et sections) pour commencer à planifier.",
      "action": "Aller aux paramètres"
    },
    "emptyWindow": {
      "title": "Aucune donnée dans cette fenêtre",
      "message": "La fenêtre PK sélectionnée ne contient aucun élément à afficher. Élargissez la plage depuis les contrôles en haut, ou revenez à l'ensemble du réseau.",
      "action": "Voir tout le réseau"
    }
  },
  "projectList": {
    "selectNetwork": "Sélectionner un réseau",
    "noNetwork": "Aucun réseau disponible."
  },
  "linearView": {
    "pkStart": "PK début",
    "pkEnd": "PK fin",
    "customRange": "Plage personnalisée",
    "orCustomRange": "Ou plage personnalisée",
    "granularity": "Pas",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "viewSettings": "Paramètres de vue",
    "showProtectionZones": "Afficher les zones de protection",
    "shownZones": "Zones affichées",
    "noTrackInWindow": "Aucune voie sur cette plage de PK.",
    "sectors": "Secteurs",
    "subSectors": "Sous-secteurs",
    "geoMarkers": "Repères",
    "buildings": "Bâtiments",
    "switches": "Aiguillages",
    "allTracks": "Toutes les voies",
    "mainTracks": "Voies principales",
    "byTrack": "Par voie",
    "trackCount": "{{count}} voies",
    "trackFilterTooltip": "Filtrer les voies",
    "defaultRangeTitle": "Plage par défaut de la vue linéaire",
    "defaultRangeDescription": "La plage de PK sur laquelle les vues linéaires s'ouvrent quand aucun secteur ni plage personnalisée n'est actif. S'applique à tous les utilisateurs de ce réseau.",
    "defaultPkStart": "PK de début par défaut",
    "defaultPkEnd": "PK de fin par défaut",
    "networkExtentHint": "Étendue du réseau : {{start}} – {{end}}",
    "defaultRangeOutsideExtent": "Cette plage dépasse l'étendue du réseau — elle sera bornée à l'étendue à l'affichage.",
    "defaultRangePartial": "Les deux bornes sont requises (ou laissez les deux vides pour effacer)",
    "defaultRangeNotAnInteger": "Les bornes doivent être des nombres entiers",
    "defaultRangeNegative": "Les bornes doivent être positives ou nulles",
    "defaultRangeEqualBounds": "Le PK de début et le PK de fin doivent être différents",
    "preferencesSavedSuccess": "Préférences enregistrées",
    "preferencesSavedError": "Échec de l'enregistrement des préférences",
    "dayPending": "En attente"
  },
  "filter": {
    "zoneKind": "Zones affichées",
    "zoneKindAll": "Toutes",
    "zoneKindSimple": "Zones simples",
    "zoneKindGroup": "Groupements"
  },
  "settings": {
    "groupGeneral": "Général",
    "groupProtections": "Protections",
    "groupTeams": "Équipes & ressources",
    "clientScopedNote": "Paramètre commun à tous les projets du client.",
    "preferences": "Préférences",
    "previewLinear": "Aperçu vue linéaire",
    "previewSynoptic": "Aperçu synoptique",
    "synopticTitle": "Synoptique",
    "synopticContradiction": "Aiguillages en contradiction sur l'ordre des voies : {{switches}}",
    "synopticOffTrack": "Aiguillages hors des segments de leur voie : {{switches}}",
    "synopticUnlinked": "Aiguillages sans voie A ou B, ignorés : {{switches}}"
  },
  "synoptic": {
    "activityDetails": "Voir le détail de l'activité",
    "contradiction": "Ordre des voies contradictoire avec un autre aiguillage",
    "offTrack": "PK hors des segments de la voie",
    "dayBanner": "La vue synoptique n'affiche qu'une journée — affichage du {{date}}",
    "dayActivities": "Activités de la journée",
    "dayLegend": "Toutes les protections de la journée sont visibles. Survolez une activité pour ne garder en évidence que les siennes.",
    "dayNoActivity": "Aucune activité ce jour",
    "dayNoMatch": "Aucune activité ne correspond aux filtres",
    "shownActivities": "Activités affichées",
    "displayedTracks": "Voies affichées",
    "displayedProtections": "Protections affichées"
  },
  "switch": {
    "nameColumn": "Nom"
  },
  "common": {
    "cancel": "Annuler",
    "expand": "Déplier {{name}}",
    "collapse": "Replier {{name}}",
    "save": "Enregistrer",
    "edit": "Modifier",
    "loading": "Chargement...",
    "delete": "Supprimer",
    "restore": "Restaurer",
    "moreActions": "Plus d'actions",
    "confirm": "Confirmer",
    "create": "Créer",
    "search": "Rechercher",
    "choose": "Choisir ...",
    "close": "Fermer",
    "clear": "Effacer",
    "selectAll": "Tout sélectionner",
    "deselectAll": "Tout désélectionner",
    "tablePagination": "{{from}} - {{to}} sur {{count}}",
    "print": "Imprimer",
    "printDayViewOnly": "Impression disponible uniquement en vue 24h (jour)",
    "printActivitiesDocTitle": "Export activités T-ops {{date}}",
    "noResult": "Aucun résultats.",
    "back": "Retour",
    "saveAndLeave": "Enregistrer et quitter",
    "leaveUnsavedTitle": "Vos dernières modifications ne sont pas enregistrées",
    "leaveUnsavedMessage": "Quitter maintenant fera perdre ces modifications. Quitter quand même, ou rester et enregistrer.",
    "leaveAnyway": "Quitter quand même"
  },
  "days": {
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche"
  },
  "permissions": {
    "forbiddenMessage": "Vous n'avez pas les permissions nécessaires pour accéder à cette page.",
    "forbiddenTitle": "Accès interdit",
    "goBack": "Retour",
    "notAllowed": "Action non autorisée"
  },
  "popup": {
    "cancel": "Annuler",
    "save": "Enregistrer"
  },
  "dictionary": {
    "title": "Gestion des dictionnaires",
    "tableTitle": "Mise à jour des termes",
    "id": "ID",
    "frVersion": "Version FR",
    "enVersion": "Version EN",
    "originVersion": "Version originale"
  },
  "error": {
    "notFound": "Non trouvé",
    "atLeastOneMember": "Choisissez au moins une zone membre",
    "unauthorized": "Non autorisé",
    "forbidden": "Interdit",
    "badRequest": "Mauvaise requête",
    "serverError": "Erreur serveur",
    "missingSector": "Veuillez remplir tous les champs de secteur ou vérifier les secteurs qui se chevauchent/manquent",
    "zodError": "Veuillez vérifier les champs obligatoires",
    "modificationError": "Une erreur s'est produite lors de la modification",
    "deleteError": "Une erreur s'est produite lors de la suppression",
    "creationError": "Une erreur s'est produite lors de la création",
    "createError": "Une erreur s'est produite lors de la création",
    "overlapActivity": "Chevauchement détecté avec des activités existantes",
    "pkNotOK": "Le PK doit être compris entre {{kmMin}} et {{kmMax}}",
    "pkNotOnTrack": "Le PK n'est sur aucun segment de la voie {{tracks}}",
    "pkNotOnNetwork": "Le PK n'est sur aucun segment du réseau",
    "form": "Veuillez compléter le formulaire puis enregistrer à nouveau",
    "kmValidationFailed": "Certains kilomètres sont invalides. Les kilomètres doivent être dans les limites du projet et dans le même sens.",
    "kmOutOfBounds": "Le kilomètre {{km}} est hors des limites du projet ({{kmStart}}-{{kmEnd}}).",
    "kmOrderInvalid": "L'ordre des kilomètres est invalide pour ce projet.",
    "required": "Ce champ est requis",
    "fieldRequired": "Ce champ est requis",
    "pkStartEqualpkEnd": "Le début doit être différent de la fin.",
    "atLeastOneSegment": "Ajoutez au moins un segment",
    "atLeastOneTrack": "Au moins une voie doit être sélectionnée.",
    "segmentValidationFailed": "Géométrie invalide pour ce projet",
    "invalidEmail": "Email invalide",
    "infoErrorAuthor": "Auteur invalide",
    "infoErrorPhone": "Numéro de téléphone invalide",
    "updateError": "Erreur lors de la mise à jour",
    "invalidResetToken": "Token de réinitialisation invalide",
    "invalidTokenRegister": "Token d'inscription invalide",
    "emailAlreadyUsedRegister": "Cet email est déjà utilisé",
    "emailNotFound": "Email non trouvé",
    "rangeNotOnSingleSegment": "Ce tronçon traverse plusieurs segments de voie. Veuillez vérifier les limites du tronçon.",
    "activityOutOfTrackBounds": "L'activité dépasse les bornes de la voie sur laquelle elle est adossée.",
    "taskLabelTooLong": "Libellé trop long ({{max}} caractères max)",
    "jobScopeRejected": "Le périmètre du job n'a pas pu être enregistré. Rouvrez l'activité et réessayez."
  },
  "userList": {
    "list": "Liste des utilisateurs",
    "add": "Inviter / Créer un utilisateur",
    "name": "Nom de l'utilisateur",
    "email": "Adresse mail",
    "invitationError": "Une erreur est survenue lors de l'envoi de l'invitation",
    "invitationSuccess": "L'invitation a été envoyée avec succès",
    "emailAlreadyExists": "L'email existe déjà",
    "noRoles": "Aucun rôle attribué",
    "networkRoles": "Rôles du réseau",
    "networkFallback": "Réseau inconnu",
    "resendInvitation": "Renvoyer l'invitation",
    "resendInvitationSuccess": "Invitation renvoyée avec succès",
    "resendInvitationError": "Erreur lors du renvoi de l'invitation",
    "statsTooltip": "Compteurs d'utilisateurs (facturation indicative)",
    "statsTitle": "Facturation (indicatif)",
    "statsRoles": "Rôles",
    "statsUsers": "utilisateurs",
    "statsAccounts": "Comptes",
    "statsActivated": "Activés",
    "statsPending": "Non activés",
    "statsLoading": "Chargement…",
    "filterByRole": "Filtrer par rôle",
    "filterByActivation": "Filtrer par statut d'activation",
    "accountActivated": "Comptes activés",
    "accountPending": "Comptes non activés"
  },
  "newUser": {
    "title": "Inviter / Créer un utilisateur",
    "mail": "Adresse mail",
    "role": "Role",
    "roleUser": "Utilisateur",
    "roleOPC": "OPC",
    "clients": "Clients",
    "errorClient": "Veuillez sélectionner au moins un client",
    "errorProjectRoles": "Veuillez sélectionner au moins un rôle de projet",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "firstName": "Prénom",
    "firstNamePlaceholder": "Prénom",
    "lastName": "Nom",
    "lastNamePlaceholder": "Nom",
    "phone": "Téléphone",
    "project": "Projet",
    "projectRoles": "Rôles par projet",
    "addRole": "Ajouter un rôle",
    "noProjectRoles": "Aucun rôle de projet",
    "noProjectRolesHint": "Ajoutez au moins un rôle de projet",
    "errorNetworkRoles": "Veuillez sélectionner au moins un rôle de réseau",
    "network": "Réseau",
    "networkRoles": "Rôles par réseau",
    "noNetworkRoles": "Aucun rôle de réseau",
    "noNetworkRolesHint": "Ajoutez au moins un rôle de réseau"
  },
  "updateUser": {
    "title": "Modifier un utilisateur",
    "firstName": "Prénom",
    "lastName": "Nom",
    "firstNameError": "Prénom non valide",
    "lastNameError": "Nom non valide",
    "telephone": "Numéro de téléphone",
    "telephoneError": "Numéro de téléphone non valide",
    "confirmDelete": "Voulez-vous vraiment supprimer cet utilisateur ?",
    "delete": "Supprimer l'utilisateur",
    "deleteError": "Erreur lors de la suppression de l'utilisateur",
    "deleteSuccess": "Utilisateur supprimé avec succès",
    "email": "Adresse email",
    "success": "Utilisateur modifié avec succès",
    "project": "Projet",
    "projectRoles": "Rôles par projet",
    "addRole": "Ajouter un rôle",
    "noProjectRoles": "Aucun rôle de projet",
    "noProjectRolesHint": "Aucun rôle attribué",
    "errorProjectSelection": "Veuillez sélectionner un projet",
    "errorNetworkSelection": "Veuillez sélectionner un réseau",
    "network": "Réseau",
    "networkRoles": "Rôles par réseau",
    "noNetworkRoles": "Aucun rôle de réseau",
    "noNetworkRolesHint": "Aucun rôle attribué",
    "error": "Erreur lors de la mise à jour"
  },
  "general": {
    "resourceCalendar": "Ressources",
    "previous": "Précédent",
    "today": "Aujourd'hui",
    "next": "Suivant",
    "week": "Semaine"
  },
  "resource": {
    "setUnavailability": "Définir une indisponibilité",
    "editUnavailability": "Modifier l'indisponibilité",
    "unavailabilityDetails": "Détails de l'indisponibilité",
    "noNote": "Aucune note",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "note": "Note",
    "periods": "Périodes",
    "unavailabilityCreated": "Indisponibilité créée",
    "unavailabilityCreateError": "Erreur lors de la création de l'indisponibilité",
    "unavailabilityUpdated": "Indisponibilité modifiée",
    "unavailabilityUpdateError": "Erreur lors de la modification de l'indisponibilité",
    "unavailabilityDeleted": "Indisponibilité supprimée",
    "unavailabilityDeleteError": "Erreur lors de la suppression de l'indisponibilité"
  },
  "dashboard": {
    "menuOverview": "Tableau de bord",
    "overviewTitle": "Tableau de bord",
    "periodLabel": "Période",
    "periodMaxHelper": "La période maximale est de 31 jours.",
    "coverageLabel": "Période couverte :",
    "kpiTotalActivities": "Activités sur la période",
    "kpiToApprove": "À approuver",
    "byStatusTitle": "Par statut",
    "byActivityTypeTitle": "Par type d'activité",
    "byTeamTitle": "Par équipe",
    "legendDeleted": "Supprimé",
    "legendCancelled": "Annulé",
    "otherSlice": "Autres",
    "noData": "Aucune donnée sur la période",
    "weeklyChartTitle": "Activités par jour",
    "reportsChartTitle": "Rapports par jour",
    "legendValidated": "Approuvé",
    "legendToApprove": "En attente",
    "todayMarker": "Aujourd'hui"
  },
  "activityList": {
    "period": "Période",
    "periodEmptyPrompt": "Choisissez une date de début et de fin pour voir les activités sur une période.",
    "periodCapped": "Une période ne peut pas dépasser {{days}} jours — la plage sélectionnée a été réduite.",
    "periodBanner": "La vue linéaire n'affiche pas de période — passage à la semaine {{week}}."
  },
  "tooltip": {
    "periodView": "Vue période"
  },
  "activityForm": {
    "groupModificationWarning": "S'applique à toutes les activités du groupe. Les modifications individuelles et l'historique seront perdus.",
    "followingModificationWarning": "S'applique à cette activité et aux suivantes. Les modifications individuelles et l'historique seront perdus.",
    "entryVoie": "Voie(s) d'entrée",
    "exitVoie": "Voie(s) de sortie",
    "voiePlaceholder": "-",
    "deleteReport": "Supprimer le rapport",
    "deleteReportTitle": "Supprimer ce rapport ?",
    "deleteReportMessage": "L'avancement et le commentaire de ce shift seront perdus. Cette action est irréversible.",
    "reportDeleted": "Rapport supprimé",
    "reportDeleteError": "Le rapport n'a pas pu être supprimé",
    "laterReportsExist": "Au moins un rapport plus récent existe déjà pour cette activité. Si vous modifiez les valeurs de ce jour, ils garderont leurs valeurs ; seul l'écart affiché pour ces jours sera recalculé."
  },
  "referential": {
    "trackIsMain": "Voie principale",
    "trackCreated": "Voie créée",
    "trackUpdated": "Voie modifiée",
    "trackDeleted": "Voie supprimée",
    "trackCreateError": "La voie n'a pas pu être créée",
    "trackUpdateError": "La voie n'a pas pu être modifiée",
    "trackInUseError": "Cette voie est encore utilisée par d'autres éléments (aiguillages, fenêtres, activités, zones…)",
    "segmentCreated": "Segment ajouté",
    "segmentUpdated": "Segment modifié",
    "segmentDeleted": "Segment supprimé",
    "segmentSaveError": "Le segment n'a pas pu être enregistré",
    "connectionCreated": "Connexion déclarée",
    "connectionUpdated": "Connexion modifiée",
    "connectionDeleted": "Connexion supprimée",
    "connectionSaveError": "La connexion n'a pas pu être enregistrée",
    "connectionDerivedError": "Cette connexion provient d'une jonction de projets : supprimez la jonction pour la retirer"
  },
  "junction": {
    "createSuccess": "Jonction créée",
    "updateSuccess": "Jonction modifiée",
    "deleteSuccess": "Jonction supprimée",
    "noJunction": "Aucune jonction sur ce réseau"
  },
  "reportList": {
    "periodCapped": "La vue Rapport n'affiche que les {{days}} premiers jours sélectionnés.",
    "cellDelta": "{{delta}} %",
    "cellProgressAfter": "({{after}} %)",
    "taskWeight": "×{{weight}}"
  }
}
